import * as React from 'react';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Switch from '@mui/material/Switch';

export default function SwitchesGroup({setWhiteBoard,SwitchLabel,firstState}) {
  const [state, setState] = React.useState({
    gilad: firstState,
    // jason: false,
    // antoine: true,
  });

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
    // console.log(event.target.checked)
    if (event.target.checked){
      setWhiteBoard(true)
    }else{
      setWhiteBoard(false)
    }
  };

  return (
    <FormControl component="fieldset" variant="standard">
      {/* <FormLabel component="legend">Assign responsibility</FormLabel> */}
      <FormGroup>
        <FormControlLabel
          control={
            <Switch checked={state.gilad} onChange={handleChange} name="gilad" />
          }
          label={SwitchLabel}
        />
        {/* <FormControlLabel
          control={
            <Switch checked={state.jason} onChange={handleChange} name="jason" />
          }
          label="Jason Killian"
        />
        <FormControlLabel
          control={
            <Switch checked={state.antoine} onChange={handleChange} name="antoine" />
          }
          label="Antoine Llorca"
        /> */}
      </FormGroup>
      {/* <FormHelperText>Be careful</FormHelperText> */}
    </FormControl>
  );
}